import React from 'react';
import { connect } from 'react-redux';
import { Grid, Button, SvgIcon, Box } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import get from 'lodash.get';
import { exportsActions } from './store';
import { appOperations } from '../../../App/store';
import { SocialPlatformNames } from './ExportsPageConstants';
import { mdiUpload } from '@mdi/js';
import isEmpty from 'lodash.isempty';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import ColoredSnackbarConstants from '../../../components/misc/ColoredSnackbar/ColoredSnackbarConstants';
import { getPublicVideoLink } from './ExportsPageHelpers';

const styles = (theme) => ({
    button: {
        ".MuiButton-startIcon": {
            position: 'absolute',
            left: theme.spacing(2)
        },
        ".MuiBox-root": {
            width: "100%"
        }
    },
    actionListItem: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0
    },
    actionListItemIcon: {
        minWidth: theme.spacing(4),
    },
    actionListItemSecondary: {
        right: 0
    },
    shareCheckbox: {
        padding: 0
    },
    actionLink: {
        textDecoration: 'none'
    }
});

class MobileExportActionsPanel extends React.Component {

    render() {
        const { classes, selectedExport } = this.props;

        return (
            <>
                <Grid>
                    <Button
                        variant='outlined'
                        fullWidth={true} className={classes.button}
                        startIcon={<GetAppRoundedIcon />}
                        disabled={get(selectedExport, 'status') !== 'Completed'}
                        onClick={this.onDownloadVideoClick}
                        color='secondary'
                    >
                        <Box>Download Video</Box>
                    </Button>
                </ Grid>
                <Grid>
                    <Button
                        fullWidth={true}
                        color='secondary'
                        variant='outlined'
                        className={classes.button}
                        disabled={get(selectedExport, 'status') !== 'Completed'}
                        onClick={() => this.onDesktopShareButtonClick(SocialPlatformNames.YOUTUBE)}
                        startIcon={<SvgIcon> <path d={mdiUpload} /> </SvgIcon>}
                    >
                        <Box>Upload to YouTube</Box>
                    </Button>
                </ Grid>
                <Grid>
                    <Button
                        variant='outlined'
                        fullWidth={true}
                        color='secondary'
                        className={classes.button}
                        disabled={get(selectedExport, 'status') !== 'Completed'}
                        onClick={() => this.onMobileShareButtonClick()}
                        startIcon={<SvgIcon> <ShareRoundedIcon /> </SvgIcon>}
                    >
                        <Box>Share</Box>
                    </Button>
                </ Grid>
            </>
        )
    }

    onDownloadVideoClick = () => {
        const { selectedExport, projectName, downloadVideoFile } = this.props;

        if (!isEmpty(selectedExport)) {
            downloadVideoFile(selectedExport, projectName, selectedExport.videoFileUrl);
        }
    }

    onDesktopShareButtonClick = (socialNetwork) => {
        const { selectedExport, videoInfo, sharePublicVideo } = this.props;
        sharePublicVideo(socialNetwork, selectedExport.exportId, get(videoInfo, 'id'), videoInfo.public);
    };

    onMobileShareButtonClick = () => {
        const { selectedExport, openSnack, videoInfo, changeVideoPublicStatus } = this.props;

        if (navigator.share) {
            if (!videoInfo.public) {
                changeVideoPublicStatus(get(videoInfo, 'id'), true, (status) => { });
            }

            const videoLink = getPublicVideoLink(!isEmpty(selectedExport) ? selectedExport.exportId : '');

            navigator.share({ url: videoLink })
                .then(() => {
                    console.log('Share successful');
                })
                .catch((error) => {
                    console.error('Error sharing:', error);
                });
        } else {
            openSnack('Share API is not supported', ColoredSnackbarConstants.SNACKBAR_WARNING);
        }
    }

    onThirdPartyAuthDialogClose = () => {
        const { setProperty } = this.props;
        setProperty('googleAuthDialogOpen', false);
    }
}

const mapStateToProps = (state) => {
    const {
        projectName,
        videoExports,
        selectedExport,
        videoInfo,
        youTubeUploadDialogOpen,
        googleAuthDialogOpen,
        googleAuthUrl
    } = state.exports;
    const {
        accountDetails
    } = state.app;

    return {
        projectName,
        videoExports,
        selectedExport,
        accountDetails,
        videoInfo,
        youTubeUploadDialogOpen,
        googleAuthDialogOpen,
        googleAuthUrl
    };
}

const mapDispatchToProps = (dispatch) => {
    const downloadVideoFile = (exportData, projectName, videoSource) => dispatch(exportsActions.downloadVideoFile(exportData, projectName, videoSource));
    const openSnack = (text, variant) => dispatch(appOperations.openSnack(text, variant));
    const changeVideoPublicStatus = (videoId, status, callback) => dispatch(exportsActions.changeVideoPublicStatus(videoId, status, callback));
    const sharePublicVideo = (socialNetwork, exportId, videoId, isVideoPublic) => dispatch(exportsActions.sharePublicVideo(socialNetwork, exportId, videoId, isVideoPublic));
    const setProperty = (key, value) => dispatch(exportsActions.setProperty(key, value));

    return {
        downloadVideoFile,
        openSnack,
        changeVideoPublicStatus,
        sharePublicVideo,
        setProperty
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(MobileExportActionsPanel, styles));